module.exports = __webpack_public_path__ + "static/media/sidebar-team-management.a114a11b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-team-management.svg
// module id = 805
// module chunks = 0